/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbSharedRefineMenuColorSelect_itemSearch$ref = any;
export type SbSharedRefineMenuFilterColor_itemSearch$ref = any;
export type SbSharedRefineMenuFilterColor_itemSearch = {
    readonly " $fragmentRefs": SbSharedRefineMenuColorSelect_itemSearch$ref;
    readonly " $refType": SbSharedRefineMenuFilterColor_itemSearch$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuFilterColor_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuColorSelect_itemSearch",
      "args": null
    }
  ]
};
(node as any).hash = '1982be8a0d269a8fc9592c9e440e3002';
export default node;
